<template>
    <!-- <modals-container></modals-container> -->
    <section>
        <header class="modal-header">
            <button @click="closeEvent" class="btn_close">닫기</button>
        </header>
        <div @click="closeEvent" style="cursor:pointer;padding-top: 30px;">
            <div>
                <img src="@/assets/img/noti_popup.png" alt="">
            </div>
        </div>
    </section>
</template>

<script>
import { mapActions } from "vuex";

export default {
    props: {
        modalInfo: {
            type: Object,
            required: true,
        },
    },
    created() {
    },
    data() {
        return {}
    },
    methods: {
        ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
        closeEvent(){
            let obj = this;
            let reqData = {
                url : "/api/auth/org/changeNotiPopupStatus",
                method : "post",
                params: {},
            };
            obj
            .COWORK_REST_SIMPLE_ACTION(reqData)
            .then((res) =>{
                if(res.errorCode !== null) {
                    let errorCode = res.errorCode;
                    obj.$emit("close");
                } else {
                    obj.$emit("close");
                }
            })
            .catch(function(err) {
                console.log(err);
            });
        }
    }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/cowork/general/main/modal/NotiPopup.vue